@if (badgeParams()) {
    <div>
        @if (badgeParams().plainText) {
            <span>
                {{ badgeParams().text | translate }}
            </span>
        } @else {
            <app-generic-badge
                [color]="badgeParams().badgeColor"
                [label]="badgeParams().text | translate"
                size="md"
                [ngbTooltip]="badgeParams().tooltip | translate"
                container="body"
            />
        }
    </div>
}
